import { Plugin, PluginKey } from "prosemirror-state";

import { isFormulaErrorSelected, isImageSelected, isSelectionInCodeBlock } from "../utils";

export type ToolbarPanel = "main" | "moreOptions" | "textStyle" | "textColor";

interface ToolbarPanelState {
  activePanel: ToolbarPanel;
}

export const toolbarPanelPluginKey = new PluginKey<ToolbarPanelState>("toolbarPanel");

/** Creates a plugin that tracks which toolbar panel is active (default: "main"). */
export function toolbarPanelPlugin(): Plugin<ToolbarPanelState> {
  return new Plugin<ToolbarPanelState>({
    key: toolbarPanelPluginKey,
    state: {
      init: () => ({ activePanel: "main" }),
      apply(tr, value) {
        const meta = tr.getMeta(toolbarPanelPluginKey) as ToolbarPanelState | undefined;
        if (meta?.activePanel !== undefined) return { activePanel: meta.activePanel };
        return value;
      },
    },
    appendTransaction(_transactions, _oldState, newState) {
      if (toolbarPanelPluginKey.getState(newState)?.activePanel !== "textColor") return null;

      // Text color panel is incompatible with these selection types — reset to the default panel.
      if (
        isSelectionInCodeBlock(newState) ||
        isFormulaErrorSelected(newState) ||
        isImageSelected(newState)
      ) {
        return newState.tr.setMeta(toolbarPanelPluginKey, { activePanel: "main" });
      }

      return null;
    },
  });
}
